export { QUERY as GetDecksQuery, default as useGetDecks } from "./GetDecks";
